export default "__VITE_ASSET__CWYOfPyw__"